import { useRef, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

const InputFile = ({ fileName, onChange, name, accept, placeholder, onBeforeClick }) => {

    const fileInputRef = useRef(null);
    const inputId = `input-file-${name || 'file'}`;
    const [displayName, setDisplayName] = useState(null);

    useEffect(() => {
        setDisplayName(fileName ?? null);
    }, [fileName]);

    const handleClick = async (e) => {
        if (e.target.tagName === 'LABEL') return;
        if (onBeforeClick) {
            const result = await onBeforeClick();
            if (result === false) return;
        }
        fileInputRef.current?.click();
    }

    const handleChange = (e) => {
        const file = e.target.files?.[0];
        if (file) setDisplayName(file.name);
        if (onChange) onChange(e);
    }

    const textToShow = displayName ?? fileName ?? placeholder ?? "No se ha seleccionado archivo";
    const rawValue = (displayName ?? fileName ?? '').trim();
    const isPlaceholder = !rawValue || rawValue === 'No se ha seleccionado archivo' || rawValue === 'No se ha seleccionado ningún archivo' || rawValue === 'Mantener foto actual';
    const hasFile = rawValue !== '' && !isPlaceholder;

    return (
        <>
            <input
                id={inputId}
                ref={fileInputRef}
                type="file"
                name={name}
                className="hidden"
                onChange={handleChange}
                accept={accept}
            />

            <div
                className="relative cursor-pointer group flex items-center mt-1 w-full space-x-1 px-3 py-2 border-b border-[#9e9e9dff] "
                onClick={handleClick}
            >
                <label
                    htmlFor={inputId}
                    className="flex-shrink-0 cursor-pointer whitespace-nowrap bg-[#1f94c2ff] text-white px-2 py-1 rounded-sm"
                >
                    Elegir archivo
                </label>

                <span className="text-[#9e9e9dff] cursor-pointer flex-grow overflow-hidden text-ellipsis whitespace-nowrap">
                    {textToShow}
                </span>

                {hasFile && (
                    <span className="flex-shrink-0 text-green-500" title="Archivo listo">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-lg" />
                    </span>
                )}

                <span className="absolute left-1/2 -translate-x-1/2 cursor-pointer -top-5 w-max bg-gray-800 text-white text-xs p-1 opacity-0 group-hover:opacity-100 transition">
                    {textToShow}
                </span>
            </div>
        </>
    )

}
export default InputFile;